import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "progress" }
const _hoisted_2 = ["aria-valuenow"]


export default /*@__PURE__*/_defineComponent({
  __name: 'DocProgressBar',
  props: {
    progress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.progress !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "aria-valuenow": __props.progress,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          style: _normalizeStyle({ width: __props.progress + '%' }),
          class: "progress__now"
        }, null, 12, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})